import React from "react";
import logo from '../images/logo.png'

interface commonTitleType {
    title:string
}

const CommonTitle:React.FC<commonTitleType> = (props) => {
    return <div className="common-title">
        <div className="_left_">
            <img src={ logo } alt=""/>
            <p>{ props.title }</p>
        </div>
        <div className="right">
            { props.children }
        </div>
    </div>
}

export default CommonTitle;
